// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let villalistSlide = new Swiper(".js-villalist-slide", {
    navigation: {
      nextEl: ".villalist-btn-next",
      prevEl: ".villalist-btn-prev",
    },
    // pagination: {                       //ページネーション（ドット）
    //     el: '.villalist-pagination',
    // },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    breakpoints: {
      769: {
        slidesPerView: 3,
      },
    },
  });

  const voiceSlide = new Swiper('.voice', {

    slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    spaceBetween: 0, // スライド間の余白（px）
    centeredSlides: true, // アクティブなスライドを中央に配置する
    autoHeight: false,

    loop: true,  // 無限ループさせる

    speed: 300, // スライドアニメーションのスピード（ミリ秒）

    grabCursor: true, // PCでマウスカーソルを「掴む」マークにする

    pagination: {
        el: '.swiper-pagination', // ページネーション要素のクラス
        clickable: true, // クリックによるスライド切り替えを有効にする
        type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    },

    navigation: {
        nextEl: '.swiper-button-next', // 「次へ」ボタン要素のクラス
        prevEl: '.swiper-button-prev', // 「前へ」ボタン要素のクラス
    },

  });
})();
